import { Button, Spinner, TextInput } from "flowbite-react";
import { StyledReportPage } from "../_styles/StyledReportPage";
import { FC } from "react";
import { CondensedCodeDataGrid } from "../../components/CondensedCodeDataGrid";
import { CodeLabel } from "../../components/CodeLabel";
import { format } from "fecha";
import { useVeloeTransacoesPage } from "./VeloeTransacoesPage.hook";

export const VeloeTransacoesPage: FC = () => {
    const {
        loading, columns, dataSource, handlePesquisar, setFiltro, filtro
    } = useVeloeTransacoesPage();

    return (
        <StyledReportPage className="shadow rounded-md py-0.5">
            <div className="py-5">
                <h2 className="px-5 mb-4 text-lg font-semibold">Consulta de Transações</h2>
                <hr />
            </div>

            <div className="flex gap-x-3 px-3 -mt-2 -mb-3 items-end">
                <div>
                    <CodeLabel className="mb-1" htmlFor="inputBases" value="Base:" />
                    <TextInput
                        id="inputBases"
                        type="text"
                        sizing={"sm"}
                        placeholder="005,006"
                        onChange={(e) => setFiltro({ ...filtro, bases: e.currentTarget.value.split(',') ?? [] })}
                    />
                </div>

                <div>
                    <CodeLabel className="mb-1" htmlFor="dateInicio" value="Início:" />
                    <TextInput
                        id="dateInicio"
                        sizing={"sm"}
                        required
                        type={"datetime-local"}
                        pattern="\d{4}-\d{2}-\d{2} \d{2}:\d{2}"
                        value={format(new Date(filtro?.startDate ?? new Date()), 'YYYY-MM-DD HH:mm')}
                        onChange={(e) => setFiltro({ ...filtro, startDate: format(e.currentTarget.valueAsDate ?? new Date(), 'DD-MM-YYYY HH:mm') })}
                    />
                </div>

                <div>
                    <CodeLabel className="mb-1" htmlFor="dateTermino" value="Término:" />
                    <TextInput
                        id="dateTermino"
                        sizing={"sm"}
                        required
                        type={"datetime-local"}
                        pattern="\d{4}-\d{2}-\d{2} \d{2}:\d{2}"
                        value={format(new Date(filtro?.endDate ?? new Date()), 'YYYY-MM-DD HH:mm')}
                        onChange={(e) => setFiltro({ ...filtro, endDate: format(e.currentTarget.valueAsDate ?? new Date(), 'DD-MM-YYYY HH:mm') })}
                    />
                </div>

                <Button
                    size={'sm'}
                    disabled={loading}
                    onClick={handlePesquisar}
                    color={'light'}>

                    {loading && <div className={(loading ?? false) ? "mr-3 text-white" : "text-white"}>
                        <Spinner size="sm" light={true} />
                    </div>}

                    {!loading && <span><i className="text-sm" /> Pesquisar</span>}
                    {loading && <span>Pesquisando...</span>}
                </Button>
            </div>

            <CondensedCodeDataGrid
                columns={columns}
                datasource={dataSource}
                header={{ filter: false }}
                readonly={true}
                pagination={{
                    limit: 500,
                    page: 1,
                    pageCount: 1,
                    recordCount: 0
                }}
                hoverable={true}
                striped={true} />

        </StyledReportPage>
    );
}